module.exports = __webpack_public_path__ + "static/media/11-10.308225eb.mp3";